import { ListableInfo, LoadingBlur, Panel } from '@ics-portal/guardian';
import { type ReactNode, useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { type Component } from '@gql/graphql';
import { GET_SINGLE_COMPONENT } from '@api/queries/components';

interface ComponentPanelProps {
    component?: Component;
    componentId?: string;
}

export function ComponentPanel({
    component: componentProps,
    componentId,
}: ComponentPanelProps): ReactNode {
    const { data: externalComponentData, loading } = useQuery(
        GET_SINGLE_COMPONENT,
        {
            variables: { componentId },
            skip: !componentId,
        },
    );

    const component = useMemo(() => {
        if (componentProps) {
            return componentProps;
        }

        if (externalComponentData) {
            return externalComponentData.components.edges[0]?.node;
        }
    }, [componentProps, externalComponentData]);

    if (!component) {
        return null;
    }

    return (
        <Panel header="Notification component">
            <LoadingBlur loading={loading}>
                <ListableInfo
                    label="Component Vendor"
                    value={component.componentVendor.name ?? ''}
                />
                <ListableInfo
                    label="Component Name"
                    value={component.name ?? ''}
                />
                <ListableInfo
                    label="Component Version"
                    value={component.version ?? ''}
                />
                <ListableInfo label="Component ID" value={component.id ?? ''} />
            </LoadingBlur>
        </Panel>
    );
}
